module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('div', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('span', {
    staticClass: "big"
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/05_Int"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("Introduction")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06_Prologue"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("Prologue")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/08_Chapter01"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("CHAPTER 1: Before the Vikings")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/11_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("CHAPTER 2: First Encounter")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/14_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("CHAPTER 3: Here Come the Vikings")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("CHAPTER 4: The Missions")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("CHAPTER 5: After the Vikings")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("CHAPTER 6: The Memories")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/24_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("CHAPTER 7: A Mystery That Lingers")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/27_Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("APPENDIXES")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/27_Appendix01#app",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("Appendix 1: Selected Chronology from the “Pentagon Papers,” 1963–64")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/28_Appendix02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("Appendix 2: The “Viking Ships”: The Nasty Boats, Swift Boats, and the "), _c('i', [_vm._v("Marjata")]), _vm._v(" Spy Ship")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/29_Biographical",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("Biographical Notes: Americans, Norwegians, and Vietnamese")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/30_Source",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("Bibliography and Sources")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/31_Ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/32_Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("Index")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d6d5693","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_Contents.vue
// module id = 66
// module chunks = 0